import { useMemo } from 'react';
import { parseYoutubeUrl } from '../utils/parseYoutubeUrl';
import { getIframeUrl } from '../utils/getIframeUrl';

export const useYoutubeIframe = (props: {
  url?: string;
  mute: boolean;
  autoPlay: boolean;
  loop: boolean;
  enabledCaptions: boolean;
  enabledControls: boolean;
  startTime: number;
  endTime: number;
}) => {
  const {
    url,
    mute,
    autoPlay,
    loop,
    enabledCaptions,
    enabledControls,
    startTime,
    endTime,
  } = props;

  const videoInfo = useMemo(() => {
    return parseYoutubeUrl(url ?? '');
  }, [url]);

  const iframeUrl = useMemo(() => {
    if (!videoInfo) {
      return '';
    }
    return getIframeUrl(videoInfo.videoId, {
      mute,
      autoPlay,
      loop,
      enabledCaptions,
      enabledControls,
      startTime,
      endTime,
    });
  }, [
    videoInfo,
    mute,
    autoPlay,
    loop,
    enabledCaptions,
    enabledControls,
    startTime,
    endTime,
  ]);

  const aspectRatioStyles = useMemo(() => {
    if (!videoInfo) {
      return {};
    }

    const aspectRatio = videoInfo.isShorts ? '9 / 16' : '16 / 9';
    return { aspectRatio, height: 'auto', width: '100%' };
  }, [videoInfo]);

  return { iframeUrl, aspectRatioStyles };
};
